<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17bLLFq/tc-custom/9780226758152.jpg?1722579937796" alt="This image is the cover for the book Sound and Affect"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sound and Affect
      </h1>
      <p class="bookDescription body article font2">
        <p>There is no place on earth that does not echo with the near or distant sounds of human activity. More than half of humanity lives in cities, meaning the daily soundtrack of our lives is filled with sound—whether it be sonorous, harmonious, melodic, syncopated, discordant, cacophonous, or even screeching. This new anthology aims to explore how humans are placed in certain affective attitudes and dispositions by the music, sounds, and noises that envelop us.<br/><br/> ?<i>Sound and Affect</i> maps a new territory for inquiry at the intersection of music, philosophy, affect theory, and sound studies. The essays in this volume consider objects and experiences marked by the correlation of sound and affect, in music and beyond: the voice, as it speaks, stutters, cries, or sings; music, whether vocal, instrumental, or machine-made; and our sonic environments, whether natural or artificial, and how they provoke responses in us. Far from being stable, correlations of sound and affect are influenced and even determined by factors as diverse as race, class, gender, and social and political experience. Examining these factors is key to the project, which gathers contributions from a cross-disciplinary roster of scholars, including both established and new voices. This agenda-setting collection will prove indispensable to anyone interested in innovative approaches to the study of sound and its many intersections with affect and the emotions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Lochhead, Eduardo Mendieta, Stephen Decatur Smith
      </h2>
      
      <p class="authorDescription body article"><B>Judith Lochhead</B>&#160;is professor of music history and theory at Stony Brook University. She is the author of&#160;<I>Reconceiving Structure&#160;in Contemporary Music: New Tools in Music Theory and Analysis</I>&#160;and coeditor of&#160;<I>Music's Immanent Future: The&#160;Deleuzian&#160;Turn in Music Studies</I>.&#160;<B>Eduardo Mendieta</B>&#160;is professor of philosophy and affiliate professor in the School of International Affairs at Pennsylvania State University. He is the&#160;coeditor of&#160;<I>The Cambridge Habermas Lexicon</I>.&#160;<B>Stephen Decatur Smith</B>&#160;is&#160;associate&#160;professor of music history and theory at Stony Brook University. His articles have appeared in&#160;<I>Popular Music</I>, the&#160;<I>Journal of Music Theory, Contemporary Music Review</I>, and&#160;<I>Opera Quarterly</I>.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?497f449e